module.exports = __webpack_public_path__ + "img/plant-en.e7828069.jpg";